/*
  商品ページの追加処理を記述します
*/

// バリエーションピッカーのボタン化
const changeVariantPicker = (_this) => {
  const variantPicker = document.getElementById(_this.dataset.target);
  variantPicker.value = _this.dataset.value;
  variantPicker.dispatchEvent(new Event("change"));

  document
    .querySelectorAll(".c-product-variant-picker__btn.is-active")
    .forEach((btn) => {
      btn.classList.remove("is-active");
    });
  const themeOptionSelectors = document.querySelectorAll(
    ".product-variants select.product-form__input"
  );
  if (
    document.querySelectorAll(".c-product-variant-picker__selected-color")
      .length > 0
  ) {
    document
      .querySelectorAll(".c-product-variant-picker__selected-color.is-active")
      .forEach((btn) => {
        btn.classList.remove("is-active");
      });
  }
  themeOptionSelectors.forEach((themeOptionSelector) => {
    const targetButton = document.querySelector(
      `.c-product-variant-picker__btn[data-target="${themeOptionSelector.id}"][data-value="${themeOptionSelector.value}"]`
    );
    targetButton.classList.add("is-active");

    const targetText = document.querySelector(
      `.c-product-variant-picker__selected-color[data-value="${themeOptionSelector.value}"]`
    );
    if (targetText) targetText.classList.add("is-active");
  });
};

const setRecommendations = () => {
  const complementaryProducts = document.querySelectorAll(
    ".complementary-products"
  );
  if (complementaryProducts.length > 0) {
    complementaryProducts.forEach((complementaryProduct) => {
      const splide = new Splide(complementaryProduct, {
        autoplay: false,
        type: "slide",
        pagination: false,
        arrows: true,
        interval: 1000,
        speed: 300,
        perPage: 4,
        perMove: 1,
        drag: true,
        start: 0,
        gap: 0,
        padding: 0,
        focus: 0,
        trimSpace: false,
        breakpoints: {
          1080: {
            arrows: true,
            perPage: 2,
            gap: 0,
            padding: 0,
          },
        },
      });
      splide.mount();
    });
  }
};

const setQuantityChangeHandler = () => {
  try {
    const quantitySelects = document.querySelectorAll(
      "[data-product-add-to-cart-quantity]"
    );

    if (quantitySelects.length === 0) {
      return;
    }

    quantitySelects.forEach((select, index) => {
      try {
        if (!select.id) {
          return;
        }

        select.addEventListener("change", function () {
          try {
            const fullId = this.id.replace("product-quantity-", "");

            let productId, extractedVariantId;
            if (fullId.includes("-")) {
              const parts = fullId.split("-");
              productId = parts[0];
              extractedVariantId = parts[1];
            } else {
              productId = fullId;
              extractedVariantId = null;
            }

            if (!productId || productId === this.id) {
              return;
            }

            const selectedQuantity = parseInt(this.value, 10);

            if (isNaN(selectedQuantity) || selectedQuantity < 1) {
              return;
            }

            const addToCartButton = document.querySelector(
              `#btn-add-to-cart-${fullId}`
            );

            if (!addToCartButton) {
              return;
            }

            const currentHref = addToCartButton.getAttribute("href");

            if (!currentHref || !currentHref.includes("?")) {
              return;
            }

            const urlParams = new URLSearchParams(currentHref.split("?")[1]);
            const variantId = urlParams.get("id");

            if (!variantId) {
              return;
            }

            const variantIdNum = parseInt(variantId, 10);
            if (isNaN(variantIdNum)) {
              return;
            }

            const newHref = `/cart/add?id=${variantId}&quantity=${selectedQuantity}`;
            addToCartButton.setAttribute("href", newHref);
          } catch (error) {}
        });
      } catch (error) {}
    });
  } catch (error) {}
};

const setProductMainSlider = () => {
  let selectElement = document.querySelector(
    '.product-form__variants[name="id"]'
  );
  let main = new Splide("#product-slider", {
    type: "slide",
    rewind: true,
    arrows: true,
  });

  let thumbnails = new Splide("#product-thumbnails", {
    perPage: 10,
    updateOnMove: true,
    pagination: false,
    isNavigation: true,
    arrows: false,
    rewind: false,
    snap: true,
    trimSpace: "move",
    focus: "left",
    breakpoints: {
      600: {
        fixedWidth: 55,
        fixedHeight: 55,
      },
    },
  });

  main.sync(thumbnails);
  main.mount();
  thumbnails.mount();

  // 以下のJSは、顧客が異なるバリアントを選択した際の画像切り替えを処理します。
  if (!selectElement) {
    return;
  }

  selectImgChange();

  selectElement.addEventListener("change", selectImgChange);

  function selectImgChange() {
    let selectedOption = selectElement.options[selectElement.selectedIndex];
    let variantImgId = selectedOption.dataset.variantImg;
    let slideList = document.querySelectorAll("#product-thumbnails ul li");

    slideList.forEach((element, index) => {
      if (element.dataset.variantImg == variantImgId) {
        thumbnails.go(index);
      }
    });
  }
};

const setCouponEvent = () => {
  const jsLabelElements = document.querySelectorAll(".js-label");
  if (jsLabelElements.length > 0) {
    jsLabelElements.forEach((element) => {
      element.addEventListener("click", function () {
        this.classList.toggle("is-show");
      });
    });
  }

  // クリップボードにコピー
  const jsCopyElements = document.querySelectorAll(".js-copy");
  jsCopyElements.forEach((element) => {
    element.addEventListener("click", function () {
      const codeElement = this.parentElement.querySelector(".code");
      if (codeElement) {
        const code = codeElement.textContent;
        navigator.clipboard.writeText(code).then(function () {
          alert("クーポンコードをコピーしました");
        });
      }
    });
  });

  const scrollToHowToElement = document.getElementById("scrollToHowTo");
  if (scrollToHowToElement) {
    scrollToHowToElement.addEventListener("click", function (e) {
      e.preventDefault();
      const expandElement = document.getElementById("Expand");
      if (expandElement) {
        const expandTop =
          expandElement.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: expandTop - 100,
          behavior: "smooth",
        });
      }

      jsLabelElements.forEach((element) => {
        element.classList.toggle("is-show");
      });
    });
  }
};

const replaceAnyGiftLink = () => {
  const anyGiftButton = document.querySelector(".anygift-e-gift-modal__ui");
  if (!anyGiftButton) {
    return;
  }

  document.querySelector(".anygift-about-link").style.display = "flex";
};

const setProductVariantStock = () => {
  const productVariantStock = document.getElementById("product-variant-stock");
  if (!productVariantStock) {
    return;
  }

  const variantSelect = document.querySelector(
    '.product-form__variants[name="id"]'
  );
  if (!variantSelect) {
    return;
  }

  const selectedVariant = variantSelect.options[variantSelect.selectedIndex];
  const currentStock = parseInt(selectedVariant.dataset.inventoryQuantity) || 0;
  const productCollections = window.product?.collections || [];
  const isAvailable = window.product?.available || false;
  let threshold = 200; // デフォルト閾値

  const targetCollections = [
    "powerhouse",
    "mobileprojector",
    "homeprojector",
    "robotcleaner",
  ];
  if (
    productCollections.some((collection) =>
      targetCollections.includes(collection.handle.toLowerCase())
    )
  ) {
    threshold = 100;
  }

  if (currentStock > 0 && isAvailable && currentStock <= threshold) {
    productVariantStock.style.visibility = "visible";
  } else {
    productVariantStock.style.visibility = "hidden";
  }
};

const setProductVariantSku = () => {
  const productVariantSku = document.getElementById("product-variant-sku");
  if (!productVariantSku) {
    return;
  }
  const variantSelect = document.querySelector(
    '.product-form__variants[name="id"]'
  );
  if (!variantSelect) {
    return;
  }
  const selectedVariant = variantSelect.options[variantSelect.selectedIndex];
  if (selectedVariant) {
    const variantColor = selectedVariant.dataset.variantColor || "";
    const variantSku = selectedVariant.dataset.variantSku || "";
    if (!variantSku || !variantColor) {
      return;
    }

    productVariantSku.innerHTML = `
    <div class="product-variant-sku-item" style="display: flex; align-items: center; gap: 4px;margin-bottom: 20px;">
      <span class="product-variant-sku-item-label" style="font-size: 10px;color:#666666;">製品型番:</span>
      <span class="product-variant-sku-item-value" style="font-size: 14px;color:#1A1A1A;">${variantSku}</span>
      <span class="product-variant-sku-item-color" style="font-size: 14px;color:#1A1A1A;">${variantColor}</span>
    </div>
    `;
  }
};

const setReviewSummaryNotes = () => {
  const summaryHeader = document.querySelector(".mxpr-summary__header");
  const reviewSubmitButton = document.querySelector(".mxpr-summary__write-review");
  if (!summaryHeader || !reviewSubmitButton) {
    return;
  }

  let shownReviewTipsFlg = false;

  reviewSubmitButton.addEventListener("click", () => {
    if(shownReviewTipsFlg === true) {
      return;
    }

    const ul = document.createElement("ul");
    ul.innerHTML = `
      <li>レビューの掲載には1週間程度お時間をいただく場合がございます。レビュー投稿の詳細は<a href="https://www.ankerjapan.com/pages/review" target="_blank">こちら</a>を確認ください。</li>
      <li>レビューを送信することで、<a href="https://www.ankerjapan.com/pages/terms" target="_blank">利用規約</a>に同意するものとみなします。</li>
      <li>ご投稿いただいた内容が不適切と判断された場合、掲載をお断りすることや、掲載されたコメントを削除させていただく場合がございます。</li>
    `;
    ul.classList.add("mxpr-summary__header-tips")
    summaryHeader.after(ul);
    shownReviewTipsFlg = true;
  });
};

document.addEventListener("DOMContentLoaded", function () {
  setProductMainSlider();
  setCouponEvent();
  setRecommendations();
  setQuantityChangeHandler();
  setProductVariantStock();
  setProductVariantSku();
  setReviewSummaryNotes();

  const variantSelect = document.querySelector(
    '.product-form__variants[name="id"]'
  );
  if (variantSelect) {
    variantSelect.addEventListener("change", setProductVariantStock);
    variantSelect.addEventListener("change", setProductVariantSku);
  }

  setTimeout(() => {
    replaceAnyGiftLink();
  }, 5000);
});


// Adjust Review Layout

